"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Youtube = exports.X = exports.Twitter = exports.Tiktok = exports.Spotify = exports.Share = exports.Instagram = exports.Facebook = void 0;
var Facebook_1 = require("./Facebook");
Object.defineProperty(exports, "Facebook", { enumerable: true, get: function () { return Facebook_1.Facebook; } });
var Instagram_1 = require("./Instagram");
Object.defineProperty(exports, "Instagram", { enumerable: true, get: function () { return Instagram_1.Instagram; } });
var Share_1 = require("./Share");
Object.defineProperty(exports, "Share", { enumerable: true, get: function () { return Share_1.Share; } });
var Spotify_1 = require("./Spotify");
Object.defineProperty(exports, "Spotify", { enumerable: true, get: function () { return Spotify_1.Spotify; } });
var Tiktok_1 = require("./Tiktok");
Object.defineProperty(exports, "Tiktok", { enumerable: true, get: function () { return Tiktok_1.Tiktok; } });
var Twitter_1 = require("./Twitter");
Object.defineProperty(exports, "Twitter", { enumerable: true, get: function () { return Twitter_1.Twitter; } });
var X_1 = require("./X");
Object.defineProperty(exports, "X", { enumerable: true, get: function () { return X_1.X; } });
var Youtube_1 = require("./Youtube");
Object.defineProperty(exports, "Youtube", { enumerable: true, get: function () { return Youtube_1.Youtube; } });
